module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="first-line">\n     ';
 if(!isNewDashboardExperience) { ;
__p += '\n        <div  class="name-container">\n            <span class="name-input group-name-input" contenteditable="' +
__e( spectator ? "false" : "true" ) +
'"></span>\n        </div>\n    ';
 } ;
__p += '\n\n	<ul class="group-variants ' +
__e(groupType ) +
'">\n        ';
 _.each(entries, function (entry, index) {
            var identifier = entry[1] ? entry[1].getIdentifier() : "";
        ;
__p += '\n            <li class="variant-icon ' +
__e(identifier) +
'' +
__e( currentVariant.id === entry[0].id ? " selected" : "" ) +
'" data-experience-id="' +
__e( entry[0].id ) +
'">\n                #' +
__e( index + 1 ) +
'\n                <span class="delete-btn" data-experience-id="' +
__e( entry[0].id ) +
'">&#215;</span>\n            </li>\n        ';
 }); ;
__p += '\n		';
 if (!spectator && !hasMaxVariants) { ;
__p += '\n		    <li class="add-variant-icon"><i class="icon-plus"></i></li>\n		';
 } ;
__p += '\n	</ul>\n\n    ';
 if(!isNewDashboardExperience) { ;
__p += '\n        <div class="vertical-line"></div>\n        <button class="push-btn push-group-btn btn btn-grey"></button>\n        <button class="publish-btn btn btn-white">Publish</button>\n            ';
 if (designFileUIEnabled) { ;
__p += '\n                    <div class="move-experience-input">\n                        <button class="move-to-experience-btn btn btn-white btn-import-action">Move Here</button>\n                        <input class="import-key input-field" type="text" placeholder="5xxxxxxxxxxxxxxxxxxxxxxx" data-original-title="" title="">\n                    </div>\n            ';
 } ;
__p += '\n    ';
 } ;
__p += '\n</div>\n\n<div class="second-line">\n    <ul class="group-variants ' +
__e(groupType ) +
'">\n        ';
 _.each(entries, function (entry, index) {
        var identifier = entry[1] ? entry[1].getIdentifier() : "";
        ;
__p += '\n        <li class="variant-icon ' +
__e(identifier) +
'' +
__e( currentVariant.id === entry[0].id ? " selected" : "" ) +
'" data-experience-id="' +
__e( entry[0].id ) +
'">\n        #' +
__e( index + 1 ) +
'\n        <span class="delete-btn" data-experience-id="' +
__e( entry[0].id ) +
'">&#215;</span>\n        </li>\n        ';
 }); ;
__p += '\n        ';
 if (!spectator && !hasMaxVariants) { ;
__p += '\n        <li class="add-variant-icon"><i class="icon-plus"></i></li>\n        ';
 } ;
__p += '\n    </ul>\n</div>\n\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/editor/GroupNavView.tpl
// module id = 2950
// module chunks = 0